import { render, staticRenderFns } from "./CustomUploadMedia.vue?vue&type=template&id=01640462&scoped=true"
import script from "./CustomUploadMedia.vue?vue&type=script&lang=js"
export * from "./CustomUploadMedia.vue?vue&type=script&lang=js"
import style0 from "./CustomUploadMedia.vue?vue&type=style&index=0&id=01640462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01640462",
  null
  
)

export default component.exports